import React from 'react';
var Check = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 30 26" },
        React.createElement("polygon", { fill: fill, points: "25.546 .45 30 4.038 12.629 25.599 0 12.809 4.07 8.791 12.196 17.02" })));
};
export default Check;
